import { SET_TIMELINE_TRANSCRIPT, SET_TRANSCRIPT_COPY_BUTTON_AVAILABILITY, TOGGLE_TRANSCRIPT } from '../../actions/actionTypes/trainer';
import type { TranscriptItem } from '../../../utils/transcript';

export const initialState = {
    timelineTranscripts: [] as TranscriptItem[],
    copyEnabled: true,
    isVisible: false
};

type TranscriptState = typeof initialState;
interface TranscriptPayload {
    timelineTranscripts?: TranscriptItem[];
    copyEnabled?: boolean;
    isVisible?: boolean;
}

interface ReducerAction {
    type: string;
    payload?: TranscriptPayload;
}

const transcriptReducer = (state: TranscriptState | undefined, action: ReducerAction): TranscriptState => {
    const currentState = state ?? initialState;
    const { type, payload = {} } = action;
    switch (type) {
        case SET_TIMELINE_TRANSCRIPT: {
            return { ...currentState, timelineTranscripts: payload.timelineTranscripts || [] };
        }
        case SET_TRANSCRIPT_COPY_BUTTON_AVAILABILITY: {
            return {
                ...currentState,
                copyEnabled: payload.copyEnabled ?? currentState.copyEnabled
            };
        }
        case TOGGLE_TRANSCRIPT: {
            return { ...currentState, isVisible: payload.isVisible ?? currentState.isVisible };
        }
        default: {
            return currentState;
        }
    }
};

export default transcriptReducer;
